<template>
  <div class="header">
    <!-- 主导航栏 -->
    <div class="main-top">
      <div class="top-left">
        <div class="logo">
          <img src="@/assets/img/logo.png" alt="小微融资机制平台" />
        </div>
        <div class="company-name">小微融资机制平台</div>
        <div class="dateNow">本网站支持<span>IPv6</span>{{ dataTime }}</div>
      </div>
      <div v-if="isUserAuth && phone" class="userInfo">
        <span class="phone">{{ phone | decryptPhoneNumber }}</span>
        <span class="logout" @click="logout">退出</span>
      </div>
      <router-link v-else to="/login" class="login">登录/注册</router-link>
    </div>
    <div class="main-nav">
      <div class="container">
        <nav class="nav-menu">
          <router-link to="/" :class="['nav-item',currentRoute == '/' ? 'active' : '' ]" >首页</router-link>
          <router-link to="/product" :class="['nav-item',currentRoute == '/product' ? 'active' : '' ]">产品业务</router-link>
          <router-link to="/contact" :class="['nav-item',currentRoute == '/contact' ? 'active' : '' ]">联系我们</router-link>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      phone: null,
      isUserAuth: false,
      dataTime: null,
    };
  },
  methods: {
    logout: function () {
      localStorage.removeItem("isUserAuth");
      localStorage.removeItem("phone");
      localStorage.removeItem("access_token");
      // 跳转到登录页
      this.$message({
        type: "success",
        message: "退出成功!",
      });
      window.location.reload()
    },
    getTime() {
      const weekDays = ["日", "一", "二", "三", "四", "五", "六"];
      const date = new Date();
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      const weekDay = weekDays[date.getDay()];
      this.dataTime = year + "年" + month + "月" + day + "日星期" + weekDay;
    },
  },
  computed:{
    currentRoute(){
      return this.$route.path
    }
  },
  filters: {
    decryptPhoneNumber(phone) {
      let contactPhone = phone;
      if (phone.length === 11) {
        contactPhone = phone.substr(0, 3) + "****" + phone.substr(7);
      }
      return contactPhone;
    },
  },
  created() {
    let phone = localStorage.getItem("phone");
    let isUserAuth = localStorage.getItem("isUserAuth");
    if (isUserAuth && phone) {
      this.phone = phone;
      this.isUserAuth = isUserAuth;
    }
    this.getTime();
  },
};
</script>

<style scoped>
.header {
  width: 100%;
  border-top: 4px solid #21ab4b;
  background-color: #fff;
}

.header .main-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1200px;
  margin: 0 auto;
  padding: 10px 0;
}

.header .main-top .top-left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.header .main-top .logo img {
  height: 50px;
}

.header .main-top .company-name {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-left: 20px;
}

.header .main-top .dateNow {
  font-size: 14px;
  margin-left: 10px;
}

.header .main-top .dateNow span {
  border: 1px solid #999;
  padding: 0 8px;
  margin-right: 16px;
  margin-left: 4px;
  border-radius: 10px;
}
.container {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.main-nav {
  height: 60px;
  background: #fff;
  background-color: #21ab4b;
}

.main-nav .container {
  height: 100%;
  align-items: center;
}
.nav-menu {
  display: flex;
  justify-content: center;
  gap: 40px;
  width: 1200px;
}

.nav-item {
  color: #fff;
  font-size: 16px;
  padding: 0 10px;
  height: 60px;
  width: 120px;
  font-weight: bold;
  text-align: center;
  line-height: 60px;
  box-sizing: border-box;
}

.nav-item:hover {
  color: #1756a4;
}
.nav-item.active {
  border-top: 2px solid #21ab4b;
  color: #21ab4b;
  background-color: #fff;
}

.login {
  width: 100px;
  height: 40px;
  border: 1px solid #21ab4b;
  border-radius: 6px;
  font-weight: bold;
  color: #21ab4b;
  text-align: center;
  line-height: 40px;
  box-sizing: border-box;
}

.login:hover {
  color: #fff;
  background-color: #21ab4b;
}

.userInfo .phone {
  color: #000;
  font-weight: bold;
}

.userInfo .logout {
  color: #21ab4b;
  margin-left: 20px;
  cursor: pointer;
}

.userInfo .logout:hover {
  opacity: #24bb51;
}
</style>